import { CabinaItinerarioMenor } from '../models/cabin/cabina-itinerario-menor';
import { TipoPaqueteEcommerceEnum } from '../enums/type-package-ecommerce.enum';
import { CamaCabinaList } from '../models/cabin/cama-cabina-list';
import { GalavailAppStatus } from '../enums/galavail-app-status.enum';
import { PassengerType } from '../enums/passenger-type.enum';
import { environment } from 'src/environments/environment';
import { SingleCabinFormCapacityType } from '../enums/single-cabin-form-capacity-type.enum';
import { PackageGBCType } from '../enums/packageGBC-type';
import { CabinService } from '../../modules/searcher/services/cabin.service';

export class CabinaItinerarioMenorWrapper {
  public cabinaItinerarioMenor: CabinaItinerarioMenor | any;

  public constructor(cabinaItinerarioMenor: CabinaItinerarioMenor) {
    cabinaItinerarioMenor.isSelected = false;
    this.setCabinaItinerarioMenor(cabinaItinerarioMenor);
  }

  public getCabinaItinerarioMenor(): CabinaItinerarioMenor | undefined {
    return this.cabinaItinerarioMenor;
  }
  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }
  // it is a method for get percent of array percents with package code
  public getAgencyPercent(): any {
    // return null; // it is for use prices machine always, delete it if you want to use arrays percents
    try {
      if (this.cabinaItinerarioMenor.percents.length !== 0) {
        // with my flag diferentA_B set type_B for get percent of array
        if (this.cabinaItinerarioMenor.percents.length === 1) {
          return Number(atob(this.cabinaItinerarioMenor.percents[0].value));
        }

        // find package code
        let valPercentObj = this.cabinaItinerarioMenor.percents.find(
          (percent: any) => percent.packageCode === this.getPackageCode()
        );
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_DEFAULT
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A
          );
        }

        if (this.isNullOrUndefined(valPercentObj)) {
          return 0;
        }
        return Number(atob(valPercentObj.value));
      } else {
        return 0;
      }
    } catch (error) {
      return 0;
    }
  }
  public getAgencyPercentOBj(): any {
    // return null; // it is for use prices machine always, delete it if you want to use arrays percents
    try {
      if (this.cabinaItinerarioMenor.percents.length !== 0) {
        // with my flag diferentA_B set type_B for get percent of array
        if (this.cabinaItinerarioMenor.percents.length === 1) {
          return this.cabinaItinerarioMenor.percents[0];
        }
        // find package code
        let valPercentObj = this.cabinaItinerarioMenor.percents.find(
          (percent: any) => percent.packageCode === this.getPackageCode()
        );
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_DEFAULT
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_B
          );
        }
        if (this.isNullOrUndefined(valPercentObj)) {
          valPercentObj = this.cabinaItinerarioMenor.percents.find(
            (percent: any) =>
              percent.packageCode === TipoPaqueteEcommerceEnum.TYPE_A
          );
        }

        if (this.isNullOrUndefined(valPercentObj)) {
          return {};
        }
        return valPercentObj;
      } else {
        return {};
      }
    } catch (error) {
      return {};
    }
  }
  private getPackageCode() {
    return this.cabinaItinerarioMenor.packageCode;
  }

  private setCabinaItinerarioMenor(
    cabinaItinerarioMenor: CabinaItinerarioMenor
  ): void {
    this.cabinaItinerarioMenor = cabinaItinerarioMenor;
  }

  public getCodigo(): number | undefined {
    return this.getCabinaItinerarioMenor()?.code;
  }

  public getCamaCabinaList(): CamaCabinaList[] {
    try {
      const value: any = this.getCabinaItinerarioMenor()?.accommodation;
      return value;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getCamaCabinaList()');
      console.error(error);
      return [];
    }
  }

  public getCamaCabina(camaCabinaListIndex: number): CamaCabinaList | null {
    try {
      if (
        this.isNullOrUndefined(this.getCamaCabinaList()) ||
        this.isNullOrUndefined(this.getCamaCabinaList()[camaCabinaListIndex]) ||
        this.getCamaCabinaList()[camaCabinaListIndex].estado ===
          GalavailAppStatus.INACTIVE
      ) {
        return null;
      }
      return this.getCamaCabinaList()[camaCabinaListIndex];
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getCamaCabina()');
      console.error(error);
      return null;
    }
  }

  public getValorTarifaPromocion(): number {
    try {
      if (
        this.isNullOrUndefined(this.getCabinaItinerarioMenor()?.promotionPublic)
      ) {
        throw new Error(
          'CabinaItinerarioMenorWrapper.getValorTarifaPromocion(): Null price'
        );
      }

      return Number(this.getCabinaItinerarioMenor()?.promotionPublic);
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getValorTarifaPromocion()');
      console.error(error);
      throw error;
    }
  }

  public getValorTarifaAgencias(): number | undefined {
    try {
      if (
        this.isNullOrUndefined(this.getCabinaItinerarioMenor()?.promotionPrice)
      ) {
        throw new Error(
          'CabinaItinerarioMenorWrapper.getValorTarifaPromocion(): Null price'
        );
      }
      const promotionPrice = this.getCabinaItinerarioMenor()?.promotionPrice;
      return promotionPrice;
    } catch (error) {
      console.log('error::', this.getCabinaItinerarioMenor());
      console.log('CabinaItinerarioMenorWrapper.getValorTarifaAgencias()');
      console.error(error);
      throw error;
    }
  }

  public getValorSuplemento(): number | undefined {
    try {
      if (this.isNullOrUndefined(this.getCabinaItinerarioMenor()?.supplement)) {
        throw new Error(
          'CabinaItinerarioMenorWrapper.getValorSuplemento(): Null price'
        );
      }
      const valueSuplement = this.getCabinaItinerarioMenor()?.supplement;

      return valueSuplement;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getValorSuplemento()');
      console.error(error);
      throw error;
    }
  }
  public getSglPercent() {
    try {
      return this.getCabinaItinerarioMenor()?.sglPercent;
    } catch (error) {
      return 0;
    }
  }

  public getValorTarifaNino(): number | undefined {
    try {
      if (
        this.isNullOrUndefined(this.getCabinaItinerarioMenor()?.childrenPrice)
      ) {
        throw new Error(
          'CabinaItinerarioMenorWrapper.getValorTarifaNino(): Null price'
        );
      }
      const valueChildrenPrice = this.getCabinaItinerarioMenor()?.childrenPrice;
      return valueChildrenPrice;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.childrenPrice()');
      console.error(error);
      throw error;
    }
  }

  public getTarifa(): number {
    try {
      const rackPrice = this.getCabinaItinerarioMenor()?.rackPrice;
      return rackPrice ? rackPrice : 0;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getTarifa()');
      console.error(error);
      throw error;
    }
  }

  public getPromo(): number | undefined {
    try {
      const promotionType = this.getCabinaItinerarioMenor()?.promotionType;
      return promotionType;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getPromo()');
      console.error();
      return undefined;
    }
  }

  public getPromoCode(): number | undefined {
    try {
      const promo = this.getPromo();
      if (this.isNullOrUndefined(promo)) {
        return undefined;
      }
      return promo;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getPromoCode()');
      console.error(error);
      return undefined;
    }
  }

  public getPromoPrice(
    cruiseCategory: number,
    includeAirFare: boolean,
    isIncludeSupplement: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number {
    try {
      let price = 0;
      price += this.getValorTarifaPromocion();
      if (isIncludeSupplement === true) {
        const valuesuplement = this.getValorSuplemento();
        price += valuesuplement ? valuesuplement : 0;
      }
      return this.getPrice(
        price,
        cruiseCategory,
        includeAirFare,
        passengerType,
        cabinaService
      );
    } catch (error) {
      console.log('BarcoService.getCruisePrice()');
      console.error(error);
      throw error;
    }
  }

  public getTravelAgencyPrice(
    cruiseCategory: number,
    includeAirFare: boolean,
    isIncludeSupplement: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number | undefined {
    try {
      let price = 0;
      //preguntar el valor de agencia
      const valortarifa = this.getValorTarifaAgencias();

      price += valortarifa ? valortarifa : 0;
      if (isIncludeSupplement === true) {
        const valueSuplement = this.getValorSuplemento();
        price += valueSuplement ? valueSuplement : 0;
      }
      return this.getPrice(
        price,
        cruiseCategory,
        includeAirFare,
        passengerType,
        cabinaService
      );
    } catch (error) {
      console.log('BarcoService.getTravelAgencyPrice()');
      console.error(error);
      throw error;
    }
  }

  public getChildPrice(
    cruiseCategory: number,
    includeAirFare: boolean,
    cabinaService: CabinService
  ): number {
    try {
      const valorTarifaNino = this.getValorTarifaNino();
      return this.getPrice(
        valorTarifaNino ? valorTarifaNino : 0,
        cruiseCategory,
        includeAirFare,
        PassengerType.CHILD,
        cabinaService
      );
    } catch (error) {
      console.log('BarcoService.getChildPrice()');
      console.error(error);
      throw error;
    }
  }

  public getAppPrice(
    cruiseCategory: number,
    includeAirFare: boolean,
    isIncludeSupplement: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number {
    try {
      const appPrice: number | undefined = this.getTravelAgencyPrice(
        cruiseCategory,
        includeAirFare,
        isIncludeSupplement,
        passengerType,
        cabinaService
      );
      return appPrice ? appPrice : 0;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getAppPrice()');
      console.error(error);
      throw error;
    }
  }

  public getAppPriceByPassengerType(
    cruiseCategory: number,
    includeAirFare: boolean,
    isIncludeSupplement: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number {
    try {
      const appPrice = this.getTravelAgencyPrice(
        cruiseCategory,
        includeAirFare,
        isIncludeSupplement,
        passengerType,
        cabinaService
      );
      return appPrice ? appPrice : 0;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getAppPrice()');
      console.error(error);
      throw error;
    }
  }

  public getWasPrice(
    cruiseCategory: number,
    includeAirFare: boolean,
    isIncludeSupplement: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number {
    try {
      let totalPrice = 0;
      const tarifa = this.getTarifa();
      totalPrice += tarifa ? tarifa : 0;
      /*
      if (this.getPromoCode() === PromoCode.PROMO_NET || this.getPromoCode() === PromoCode.PROMO_2_X_1) {
        totalPrice += this.getTarifa();
      } else {
        totalPrice += this.getValorTarifaPromocion();
      }
      */
      includeAirFare = !this.getIsitIncludedAirTickets() ? includeAirFare : false;
      if (includeAirFare === true) {
        totalPrice += cabinaService.getAirFarePriceRate(passengerType);
      }

      //  return this.getPrice(totalPrice, cruiseCategory, includeAirFare, passengerType, cabinaService);
      return Math.round(totalPrice);
    } catch (error) {
      console.log('BarcoService.getCruisePrice()');
      console.error(error);
      return 0;
    }
  }

  private getPrice(
    price: number,
    cruiseCategory: number,
    includeAirFare: boolean,
    passengerType: PassengerType,
    cabinaService: CabinService
  ): number {
    try {
      const promoCode = this.getCabinaItinerarioMenor()?.promotionType;

      includeAirFare = !this.getIsitIncludedAirTickets()
        ? includeAirFare
        : false;

      return cabinaService.getAppPrice(
        price,
        cruiseCategory,
        promoCode ? promoCode : 0,
        includeAirFare,
        passengerType,
        this.getAgencyPercent()
      );
    } catch (error) {
      console.log('BarcoService.getCruisePrice()');
      console.error(error);
      throw error;
    }
  }

  public getCapacidad(): number {
    try {
      const capacityAdults = this.getCabinaItinerarioMenor()?.capacity;
      return this.getAppCapacity(capacityAdults ? capacityAdults : 0);
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getCapacidad()');
      console.error(error);
      return 0;
    }
  }

  private isCapacityDynamic(): boolean {
    try {
      const type: SingleCabinFormCapacityType =
        environment.single_cabin_form_capacity.type;
      if (
        this.isNullOrUndefined(type) ||
        type === SingleCabinFormCapacityType.FIXED ||
        this.isNullOrUndefined(
          environment.single_cabin_form_capacity.capacity ||
            isNaN(environment.single_cabin_form_capacity.capacity)
        )
      ) {
        return false;
      } else if (type === SingleCabinFormCapacityType.DYNAMIC) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.isCapacityDynamic()');
      console.error(error);
      return false;
    }
  }

  private getSingleCabinFormFixedCapacity(): number {
    try {
      return environment.single_cabin_form_capacity.capacity || 0;
    } catch (error) {
      console.log(
        'CabinaItinerarioMenorWrapper.getSingleCabinFormFixedCapacity()'
      );
      console.error(error);
      return 0;
    }
  }

  private getAppCapacity(realCapacity: number): number {
    try {
      if (this.isCapacityDynamic() === true) {
        return realCapacity;
      } else {
        return this.getSingleCabinFormFixedCapacity() <= realCapacity
          ? this.getSingleCabinFormFixedCapacity()
          : realCapacity;
      }
    } catch (error) {
      console.log();
      console.error(error);
      return 0;
    }
  }

  public getCapacidadAdultos(): number {
    try {
      const capacityAdults = this.getCabinaItinerarioMenor()?.capacityAdults;
      return this.getAppCapacity(capacityAdults ? capacityAdults : 0);
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getCapacidadAdultos()');
      console.error(error);
      return 0;
    }
  }

  public getCapacidadNinos(): number {
    try {
      const capacityChildren =
        this.getCabinaItinerarioMenor()?.capacityChildren;
      return this.getAppCapacity(capacityChildren ? capacityChildren : 0);
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getCapacidadNinos()');
      console.error(error);
      return 0;
    }
  }

  public getCabinaFullName(): string {
    try {
      return (
        this.getCabinaItinerarioMenor()?.deck +
        ' - ' +
        this.getCabinaItinerarioMenor()?.type
      );
    } catch (error) {
      console.log('CabinaitinerarioMenorWrapper.getCabinaFullName()');
      console.error(error);
      return '';
    }
  }
  public getDeck(): string {
    try {
      const itinerary = this.getCabinaItinerarioMenor()?.deck;
      return itinerary ? itinerary : '';
    } catch (error) {
      console.log('CabinaitinerarioMenorWrapper.getCabinaFullName()');
      console.error(error);
      return '';
    }
  }
  public getType(): string {
    try {
      const type = this.getCabinaItinerarioMenor()?.type;
      return type ? type : '';
    } catch (error) {
      console.log('CabinaitinerarioMenorWrapper.getCabinaFullName()');
      console.error(error);
      return '';
    }
  }
  public getFotoCabinaList(): string[] {
    try {
      const images = this.getCabinaItinerarioMenor()?.images;
      return images ? images : [];
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getFotoCabinaList()');
      console.error(error);
      return [];
    }
  }

  public getFotoCabinaListImageNames(): string[] {
    try {
      const fotoCabinaListImageNameArray = this.getFotoCabinaList();
      return fotoCabinaListImageNameArray;
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getFotoCabinaList()');
      console.error(error);
      return [];
    }
  }

  public getFotoCabinaListMainImage(): string {
    try {
      const defaultIndex = 0;
      const fotoCabinaListImageNames: string[] =
        this.getFotoCabinaListImageNames();
      return fotoCabinaListImageNames[defaultIndex];
    } catch (error) {
      console.log('CabinaItinerarioMenorWrapper.getFotoCabinaListMainImage()');
      console.error(error);
      return '';
    }
  }
  public getIsSelected(): boolean {
    try {
      const isSelected = this.getCabinaItinerarioMenor()?.isSelected;
      return isSelected ? isSelected : false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  public getIsitIncludedAirTickets(): boolean {
    try {
      return (
        Number(this.getCabinaItinerarioMenor()?.packageGBCCode) ===
        Number(PackageGBCType.INCLUDES_AIR_TICKETS)
      );
    } catch (error) {
      return false;
    }
  }
}
